import {Injectable} from '@angular/core';
import {NgxUiTourStep} from '@shared/models/ngx-ui-tour.model';
import {LoginService} from './login.service';
import {ngxUiTourStepDefaults, ngxUiTourStepsDiary, ngxUiTourStepsHome, ngxUiTourStepsMenu, ngxUiTourStepsProfile} from '@shared/constants/ngx-ui-tour.constants';
import {HttpClient} from '@angular/common/http';
import {I18nService} from '@services/i18n.service';
import {CircleService} from './circle.service';

@Injectable({
  providedIn: 'root'
})
export class NgxUiTourService {
  currentTourName: string;

  constructor(
    private loginService: LoginService,
    private circleService: CircleService,
    private http: HttpClient,
    private i18nService: I18nService
  ) { }

  getTourName(): string {
    return this.currentTourName;
  }

  setTourName(newTourName: string): void {
    this.currentTourName = newTourName;
  }

  isTourStarted(): boolean {
    return !!this.currentTourName;
  }

  isTourCompleted(tourName: string): boolean {
    return this.loginService.getTourCompleted(tourName);
  }

  async setTourCompleted(tourName = this.currentTourName, tourCompleted = true): Promise<void> {
    await this.setTourCompletedBack(tourName, tourCompleted);
    this.loginService.setTourCompleted(tourName, tourCompleted);
  }

  setTourCompletedBack(tourName: string, tourCompleted: boolean): Promise<void> {
    const url = '/api/v1/user/tour';
    const model = {tourName, tourCompleted};
    return this.http.put<void>(url, model).toPromise();
  }

  getTourStepDefaults(): NgxUiTourStep {
    return ngxUiTourStepDefaults;
  }

  getTourStepsHome(): NgxUiTourStep[] {
    // Add hide attrib to 'home.language' item
    const homeLanguageStep = ngxUiTourStepsHome.find(step => step.anchorId === 'home.language');
    if (homeLanguageStep) {
      homeLanguageStep.hide = this.i18nService.getActiveLanguageValues().length < 2;
    }

    return ngxUiTourStepsHome;
  }

  async getTourStepsMenu(): Promise<NgxUiTourStep[]> {
    // Add hide attrib to 'menu.access-as' item
    const menuAccessAsStep = ngxUiTourStepsMenu.find(step => step.anchorId === 'menu.access-as');
    if (menuAccessAsStep) {
      menuAccessAsStep.hide = !(await this.circleService.getHasAuthorizedPatients());
    }

    return ngxUiTourStepsMenu;
  }

  getTourStepsProfile(): NgxUiTourStep[] {
    return ngxUiTourStepsProfile;
  }

  getTourStepsDiary(): NgxUiTourStep[] {
    return ngxUiTourStepsDiary;
  }
}
